export interface CharterAlternateTimeRequest {
  id?: number;
  charterId: number;
  vesselId: number;
  customerEmail: string;
  timeSelections: string[];
  selectedTime: string;
  responseStatus: CustomerResponses;
}

export enum CustomerResponses {
  PENDING_CUSTOMER_RESPONSE = 'Pending customer response',
  TIME_SELECTED = 'Time selected',
  CUSTOMER_DECLINED = 'Customer declined proposed times',
}
